// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.admin-chat[data-v-06412ce0] {\n  background-color: #fff;\n}\n.admin-chat__iframe[data-v-06412ce0] {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
